import processCalcTotalsRebuildReasonAppliedAdjsHarness from './processCalcTotalsRebuildReasonAppliedAdjsHarness.js'
import processResetTotalsReasonAdjsHarness from './processResetTotalsReasonAdjsHarness.js'
import resetSkillAdjTotalsReasons from '../helpers/resetSkillAdjTotalsReasons.js'
import removeRuneSkillAdjs from '../helpers/removeRuneSkillAdjs.js'
//--------------------------
// process remove rune adjs
//--------------------------
export default function processRemoveRuneAdjs({ rune_name, character }) {
  console.log('--------------------------')
  console.log('IN processRemoveRuneAdjs rune = ', rune_name)
  //-----------------------
  // defensive check parms
  //-----------------------
  if (!rune_name || !character) {
    console.error('processRemoveRuneAdjs: missing required parms')
    return { rune_name, character }
  }
  /*
  NOTES:
  ------
    A. remove embedded adjs: within skills, characteristics, abilties i.e. from the targets of the adjs 
      e.g. disable Darkness Rune removes +10 Stealth from Stealth skill

    B. remove detail adjs from targets of rune adjs
      - character.skill_adjs, character.characteristic_adjs, character.ability_adjs

    C. remove manually assigned specific adjs associated with named rune 
      e.g. remove +1 to darkness runecasting skill adj during Darkness Rune removal
      
  */
  console.log('character.skill_adjs before removal:', window.$deepCopy(character.skill_adjs))
  console.log(
    'character.characteristic_adjs before removal:',
    window.$deepCopy(character.characteristic_adjs),
  )
  console.log('character.ability_adjs before removal:', window.$deepCopy(character.ability_adjs))
  //=======================================================================================
  //
  //                                     SKILL ADJS
  //
  //=======================================================================================
  //=======================================================================================
  // A0. clear totals/reasons (skill adjs)
  //---------------------------------------
  console.log('----------------------------------------')
  console.log('A0. character.skill_adjs.length = ', character.skill_adjs.length)
  if (character.skill_adjs && character.skill_adjs.length > 0) {
    console.log(
      'A0.1 off to processResetTotalsReasonAdjsHarness with skill_adjs count = ',
      character.skill_adjs.length,
    )
    console.log(
      'A0.2 character.skill_adjs before rebuild = ',
      window.$deepCopy(character.skill_adjs),
    )
    character = processResetTotalsReasonAdjsHarness({
      adjs: character.skill_adjs,
      category: 'skill',
      character,
    })
  }
  console.log('A0.3 character.skill_adjs after rebuild = ', window.$deepCopy(character.skill_adjs))
  //=======================================================================================
  // A1. remove embedded/detailed skill adjs for rune name e.g. +10 Athletics
  //------------------------------------------------------------------------------
  console.log('=================================================================')
  console.log('=================================================================')
  console.log('A1.1 removing adjs for rune = ', rune_name)
  //-------------
  // loop skills
  //-------------
  character.skills.forEach((s) => {
    // console.log('----------------------------------------')
    // console.log('A1.2 loop - processing skill = ', s)
    if (!s.integrated_rune_skill_adjs) return
    // console.log('A1.3 got integrated_rune_skill_adjs cnt = ', s.integrated_rune_skill_adjs.length)
    //-----------------------------------------------------
    // loop embedded adjs backwards to enable safe removal
    //-----------------------------------------------------
    for (let i = s.integrated_rune_skill_adjs.length - 1; i >= 0; i--) {
      console.log('----------------------------------------')
      console.log(`A1.4 ${s.name} = integrated_rune_skill_adjs loop i = ${i}`)
      //---------
      // ref adj
      //---------
      const adj = s.integrated_rune_skill_adjs[i]
      console.log('A1.5 processing s.integrated_rune_skill_adjs[i] = ', window.$deepCopy(adj))
      //-----------------
      // match rune name
      //-----------------
      if (adj.rune_name === rune_name) {
        console.log('A1.6 got matching rune name = ', adj.rune_name)
        console.log('A1.7 remove entry in integrated_rune_skill_adjs at idx = ', i)
        //--------------------------------------------------
        // reset skill top-level adj props (totals/reasons)
        //--------------------------------------------------
        s = resetSkillAdjTotalsReasons(s)
        //---------------------
        // remove embedded adj
        //---------------------
        s.integrated_rune_skill_adjs.splice(i, 1)
      }
    }
  })
  //=======================================================================================
  // A2. remove detailed skill adjs for this rune name e.g. +1 My Darkness Runecasting Adj
  //---------------------------------------------------------------------------------------
  character.skill_adjs = removeRuneSkillAdjs({
    rune_name,
    skill_adjs: character.skill_adjs,
  })
  //=======================================================================================
  // A3. process save skill adjs (update totals/reasons)
  //-----------------------------------------------------
  console.log('----------------------------------------')
  console.log('A2. character.skill_adjs.length = ', character.skill_adjs.length)
  if (character.skill_adjs && character.skill_adjs.length > 0) {
    console.log(
      'A2.1 off to processCalcTotalsRebuildReasonAppliedAdjsHarness with skill_adjs count = ',
      character.skill_adjs.length,
    )
    console.log(
      'A2.2 character.skill_adjs before rebuild = ',
      window.$deepCopy(character.skill_adjs),
    )
    character = processCalcTotalsRebuildReasonAppliedAdjsHarness({
      adjs: character.skill_adjs,
      category: 'skill',
      character,
      add_only: false,
    })
  }
  //=======================================================================================
  //
  //                                 CHARACTERISTIC ADJS
  //
  //=======================================================================================
  //=======================================================================================
  // B0. clear totals/reasons (characteristic adjs)
  //------------------------------------------------
  console.log('----------------------------------------')
  console.log('B0. character.characteristic_adjs.length = ', character.characteristic_adjs.length)
  if (character.characteristic_adjs && character.characteristic_adjs.length > 0) {
    console.log(
      'B0.1 off to processCalcTotalsRebuildReasonAppliedAdjsHarness with characteristic_adjs count = ',
      character.characteristic_adjs.length,
    )
    character = processResetTotalsReasonAdjsHarness({
      adjs: character.characteristic_adjs,
      category: 'characteristic',
      character,
    })
  }
  //=======================================================================================
  // B1. remove embedded/detailed characteristic adjs for rune name e.g. +1 STR
  //--------------------------------------------------------------------------------
  console.log('=================================================================')
  console.log('=================================================================')
  console.log('B1. removing characteristic adjs for rune = ', rune_name)
  //----------------------
  // loop characteristics
  //----------------------
  character.characteristics.forEach((s) => {
    console.log('----------------------------------------')
    console.log('B1.2 loop - processing characteristic = ', s.name)
    if (!s.integrated_rune_characteristic_adjs) return
    console.log(
      'B1.3 got integrated_rune_characteristic_adjs cnt = ',
      s.integrated_rune_characteristic_adjs.length,
    )
    //-----------------------------------------------------
    // loop embedded adjs backwards to enable safe removal
    //-----------------------------------------------------
    for (let i = s.integrated_rune_characteristic_adjs.length - 1; i >= 0; i--) {
      console.log('----------------------------------------')
      console.log('B1.4 integrated_rune_characteristic_adjs loop i = ', i)
      //---------
      // ref adj
      //---------
      const adj = s.integrated_rune_characteristic_adjs[i]
      console.log(
        'B1.5 processing s.integrated_rune_characteristic_adjs[i] = ',
        window.$deepCopy(adj),
      )
      //-----------------
      // match rune name
      //-----------------
      if (adj.rune_name === rune_name) {
        console.log('B1.6 got matching rune name = ', adj.rune_name)
        console.log('B1.7 remove entry in integrated_rune_characteristic_adjs at idx = ', i)
        //---------------------
        // remove embedded adj
        //---------------------
        s.integrated_rune_characteristic_adjs.splice(i, 1)
        //--------------------------------------
        // find index in detailed adj array
        //--------------------------------------
        const adjIdx = character.characteristic_adjs.findIndex(
          (a) => a.name === adj.name && a.adj_reason?.includes(rune_name),
        )
        console.log('B1.8 adjIdx = ', adjIdx)
        //-------------
        // found index
        //-------------
        if (adjIdx !== -1) {
          console.log('B1.9 adj found in characteristic_adjs = ', window.$deepCopy(adj))
          //------------------------------------
          // remove adj from detailed array
          //------------------------------------
          console.log('B1.10 remove adj from detailed characteristic_adjs at idx = ', adjIdx)
          character.characteristic_adjs.splice(adjIdx, 1)
          // } else {
          //   console.error('B1.11 no matching adjIdx found in detailed characteristic_adjs')
        }
      }
    }
  })
  //=======================================================================================
  // B2. process save characteristic adjs (update totals/reasons)
  //--------------------------------------------------------------
  console.log('----------------------------------------')
  console.log('B2. character.characteristic_adjs.length = ', character.characteristic_adjs.length)
  if (character.characteristic_adjs && character.characteristic_adjs.length > 0) {
    console.log(
      'B2.1 off to processCalcTotalsRebuildReasonAppliedAdjsHarness with characteristic_adjs count = ',
      character.characteristic_adjs.length,
    )
    character = processCalcTotalsRebuildReasonAppliedAdjsHarness({
      adjs: character.characteristic_adjs,
      category: 'characteristic',
      character,
      add_only: false,
    })
  }
  //=======================================================================================
  //
  //                                   ABILITY ADJS
  //
  //=======================================================================================
  //=======================================================================================
  // C0. clear totals/reasons (ability adjs)
  //-----------------------------------------
  console.log('----------------------------------------')
  console.log('C0. character.ability_adjs.length = ', character.ability_adjs.length)
  if (character.ability_adjs && character.ability_adjs.length > 0) {
    console.log(
      'C0.1 off to processCalcTotalsRebuildReasonAppliedAdjsHarness with ability_adjs count = ',
      character.ability_adjs.length,
    )
    character = processResetTotalsReasonAdjsHarness({
      adjs: character.ability_adjs,
      category: 'ability',
      character,
    })
  }
  //=======================================================================================
  // C1. remove detailed ability adjs e.g. +1 melee damage
  //-------------------------------------------------------
  console.log('=================================================================')
  console.log('=================================================================')
  console.log('C. removing ability adjs for rune = ', rune_name)
  character.ability_adjs.forEach((adj) => {
    console.log('C1.1 processing adj = ', window.$deepCopy(adj))
    //-------------------------------------------------
    // only process adjs that are linked to this rune
    // (others are manual/general ability adjs)
    //-------------------------------------------------
    if (!adj.adj_reason || !adj.adj_reason.includes(rune_name)) {
      console.log('C1.1a adj not linked to rune - skipping')
      return
    }
    //----------------------------------
    // find index in detailed adj array
    //----------------------------------
    const adjIdx = character.ability_adjs.findIndex(
      (a) => a.name === adj.name && a.adj_reason?.includes(rune_name),
    )
    console.log('C1.2 adjIdx = ', adjIdx)
    //-------------
    // found index
    //-------------
    if (adjIdx !== -1) {
      console.log('C1.3 adj found in ability_adjs = ', window.$deepCopy(adj))
      console.log('C1.4 remove adj from detailed ability_adjs at idx = ', adjIdx)
      //------------------------------------
      // remove adj from detailed array
      //------------------------------------
      character.ability_adjs.splice(adjIdx, 1)
    } else {
      console.error('C1.11 no matching adjIdx found in detailed ability_adjs')
    }
  })
  //=======================================================================================
  // C2. process save ability adjs
  //-------------------------------
  console.log('----------------------------------------')
  console.log('C2. character.ability_adjs.length = ', character.ability_adjs.length)
  //===============================
  // C2.1 where ability adjs exist
  //-------------------------------
  if (character.ability_adjs && character.ability_adjs.length > 0) {
    console.log(
      'C2.1 off to processCalcTotalsRebuildReasonAppliedAdjsHarness with ability_adjs count = ',
      character.ability_adjs.length,
    )
    character = processCalcTotalsRebuildReasonAppliedAdjsHarness({
      adjs: character.ability_adjs,
      category: 'ability',
      character,
      add_only: false,
    })
    //======================
    // C2.2 no ability adjs
    //----------------------
  } else {
    console.log('C2.2 no ability adjs to process')
  }
  //=======================================================================================
  // END OF PROCESSING
  //=======================================================================================
  console.log('===============================================================')
  console.log('FINAL character.skill_adjs after removal:', window.$deepCopy(character.skill_adjs))
  console.log(
    'FINAL character.characteristic_adjs after removal:',
    window.$deepCopy(character.characteristic_adjs),
  )
  console.log(
    'FINAL character.ability_adjs after removal:',
    window.$deepCopy(character.ability_adjs),
  )
  console.log('===============================================================')
  //--------------------------------------------------------------
  // return mutated objects for clarity (optional use by callers)
  //--------------------------------------------------------------
  return character
}
